import { User } from '@/types';

const LOCAL_STORAGE_KEY_ACCESS_TOKEN = 'accessToken';
const LOCAL_STORAGE_KEY_LOCAL_USER = 'localUser';
const LOCAL_STORAGE_KEY_IS_DARK_MODE_ENABLED = 'isDarkModeEnabled';

export default class LocalStorageService {
  public getAccessToken(): string | null {
    const token: string | null = localStorage.getItem(LOCAL_STORAGE_KEY_ACCESS_TOKEN);
    if (!token) {
      // TAB: A bug can cause clients to have 'undefined' stored as their token, so clear that out
      this.removeAccessToken();
    }

    return token;
  }

  public setAccessToken(accessToken: string) {
    localStorage.setItem(LOCAL_STORAGE_KEY_ACCESS_TOKEN, accessToken);
  }

  public removeAccessToken() {
    localStorage.removeItem(LOCAL_STORAGE_KEY_ACCESS_TOKEN);
  }

  public getLocalUser(): User | null {
    const localUserString: string | null = localStorage.getItem(LOCAL_STORAGE_KEY_LOCAL_USER);
    if (!localUserString) {
      return null;
    }

    let localUser: User | null = null;
    try {
      localUser = JSON.parse(localUserString);
    } catch {
      console.error('Failed to parse localUser from localStorage. Removing entry.');
      this.removeLocalUser();
      return null;
    }

    return localUser;
  }

  public setLocalUser(localUser: User) {
    localStorage.setItem(LOCAL_STORAGE_KEY_LOCAL_USER, JSON.stringify(localUser));
  }

  public removeLocalUser() {
    localStorage.removeItem(LOCAL_STORAGE_KEY_LOCAL_USER);
  }

  public isDarkModeEnabled(): boolean {
    const isDarkModeEnabledString: string | null = localStorage.getItem(LOCAL_STORAGE_KEY_IS_DARK_MODE_ENABLED);
    if (isDarkModeEnabledString === null) {
      return false;
    }

    return (isDarkModeEnabledString === 'true');
  }

  public setDarkModeEnabled(enabled: boolean) {
    const enabledString = (enabled) ? 'true' : 'false';
    localStorage.setItem(LOCAL_STORAGE_KEY_IS_DARK_MODE_ENABLED, enabledString);
  }
}
